







import { Component, Prop, Vue } from 'vue-property-decorator';
import { ThreadDump } from '@service/solr/admin/info';

@Component
export default class ThreadDumpItem extends Vue {
  @Prop()
  private thread!: ThreadDump;
}
